export class BillingDiscrepancyRequestReasonFilter {
    public IncludeInactive?: boolean;
    public BillingDiscrepancyRequestTypeID?: number;
}

export default BillingDiscrepancyRequestReasonFilter;